import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { toFullName } from '@repo/toolkit/to-full-name'
import Badge from '@repo/ui/badge'
import { EmailIcon, TelephoneIcon } from '@repo/ui/icons'
import InnerBox from '@repo/ui/inner-box'
import Typography from '@repo/ui/typography'

import { TripProperties } from '../../lib/types/models/trip/properties.trip'
import { TripBasic } from '../../lib/types/models/trip/trip'
import { formatPhoneNumber } from '../../utils/functions/format-phone-number'
import TransportPicto from './transport-picto'

export type ContactInfo = {
  firstName: string
  lastName: string
  email: string
  phoneNumber: string
  profilePicture?: string
  trip?: TripBasic
  position?: string
}

const ContactCard = ({
  firstName,
  lastName,
  email,
  phoneNumber,
  profilePicture,
  trip,
  position
}: ContactInfo) => {
  return (
    <InnerBox className="bg-white-hover p-5 rounded-xl py-5 px-6 flex justify-center items-center flex-col gap-4">
      <img src={profilePicture ?? '/profile-default.jpg'} className="w-20 h-20 rounded-full" />
      <div className="flex flex-col items-center gap-1">
        <Typography variant="text" color={tailwindColors.primary.DEFAULT}>
          {toFullName(firstName, lastName)}
        </Typography>
        <Badge variant="secondaryRed" text={position} />
        {trip && (
          <InnerBox className="pt-1 pr-2 pb-1 pl-1 rounded-lg flex flex-row items-center gap-1 text-nowrap">
            {trip.transportMeans?.picto && <TransportPicto picto={trip?.transportMeans?.picto} />}
            <Typography variant="tag" color={tailwindColors.black.DEFAULT}>
              {TripProperties.getTripLabel(trip)}
            </Typography>
          </InnerBox>
        )}
      </div>
      <div className="h-1 w-full border-t border-dashed border-grey-light" />
      <div className="flex flex-col items-center gap-1">
        <div className="flex items-center gap-1">
          <EmailIcon color={tailwindColors.grey.DEFAULT} />
          <Typography variant="secondary-body" color={tailwindColors.grey.DEFAULT}>
            {email}
          </Typography>
        </div>
        <div className="flex items-center gap-1">
          <TelephoneIcon color={tailwindColors.grey.DEFAULT} />
          <Typography variant="secondary-body" color={tailwindColors.grey.DEFAULT}>
            {formatPhoneNumber(phoneNumber)}
          </Typography>
        </div>
      </div>
    </InnerBox>
  )
}

export default ContactCard
